import { InputNames } from "../error/validation-slice";

export const LABELS = {
  EMAIL_ADDRESS: "メールアドレス",
  PASSWORD: "パスワード",
  NEW_PASSWORD: "新しいパスワード",
  NEW_PASSWORD_CONFIRMATION: "新しいパスワード（確認）",
  VERIFICATION_CODE: "認証コード",
  TITLE: "d払い加盟店サイト",
};

export const INPUT_NAMES = {
  EMAIL_ADDRESS: "username" as keyof InputNames,
  PASSWORD: "password" as keyof InputNames,
  NEW_PASSWORD: "newPassword" as keyof InputNames,
  NEW_PASSWORD_CONFIRMATION: "confirmNewPassword" as keyof InputNames,
  VERIFICATION_CODE: "code" as keyof InputNames,
};

export const COGNITO_ERR_MSG = {
  wrongPassword: "Incorrect username or password.",
  userNotFound: "User does not exist.",
  disabledUser: "User is disabled.",
  incorrectUserType: "PreAuthentication failed with error access denied.",
  lockedUser: "Password attempts exceeded",
  sessionExpired: "Invalid session for the user.",
  emailNotExist: "Username/client id combination not found.",
  incorrectResetCode: "Invalid verification code provided, please try again.",
  passwordPolicyNotSatisfied: "Password does not conform to policy:",
  passwordPolicyDidNotSatisfied: "Password did not conform with policy:",
  resetBlocked: "Attempt limit exceeded, please try after some time.",
  expiredTempPassword:
    "Temporary password has expired and must be reset by an administrator.",
};
